import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Oculta los códigos numéricos iniciales de concepto CaixaBank ("03 — 046 — REAL...")
export function shortConcept(concept) {
  if (!concept) return concept;
  const parts = concept.split(" — ");
  while (parts.length > 1 && /^\d+$/.test(parts[0])) parts.shift();
  return parts.join(" — ");
}

const MONTHS_ES = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];

export function monthLabel(ym) {
  const [y, m] = ym.split("-");
  return `${MONTHS_ES[Number(m) - 1]} ${y}`;
}

export function monthOptions(fromYM = "2023-09") {
  const now = new Date();
  const out = [];
  let y = now.getFullYear(), m = now.getMonth() + 1;
  for (;;) {
    const ym = `${y}-${String(m).padStart(2, "0")}`;
    out.push({ value: ym, label: monthLabel(ym) });
    if (ym === fromYM) break;
    m -= 1;
    if (m === 0) { m = 12; y -= 1; }
  }
  return out;
}

export function monthRangeFor(ym) {
  const [y, m] = ym.split("-").map(Number);
  const last = new Date(y, m, 0).getDate();
  return [`${ym}-01`, `${ym}-${String(last).padStart(2, "0")}`];
}
